import {
	PropsWithChildren,
	ReactElement,
	ReadonlyRefObject
} from "react";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { ErrorPageContainer } from "../ErrorPage/ErrorPageContainer";
import {
	resetHttpError,
	HttpErrorData,
	useGlobalError
} from "../ErrorPage/errorStore";
import { useEffectSkipFirstRender, useSynchronizedRef } from "client/Hooks";
import { useLocation } from "react-router";
import { hasImplicitDependencyOn } from "client/Misc/reactUtils";

export const App = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	const httpError: HttpErrorData | null = useGlobalError();
	const httpErrorRef: ReadonlyRefObject<typeof httpError> = useSynchronizedRef(httpError);

	const {
		pathname,
		hash,
		search
	 } = useLocation();

	useEffectSkipFirstRender(
		(): void => {
			hasImplicitDependencyOn(pathname, hash, search);

			if (httpErrorRef.current) {
				resetHttpError();
			}
		},
		[
			pathname,
			hash,
			search,
			httpErrorRef
		]
	);

	if (httpError) {
		return (
			<ErrorPageContainer>
				<ErrorPage httpCode={httpError.statusCode} />
			</ErrorPageContainer>
		);
	}

	return (
		<>{children}</>
	);
};
App.displayName = "App";